






























import Vue from "vue";
import { Component } from "vue-property-decorator";
import CommunicationCardViewComponent from '@/components/App/Modules/GMS/Communication/Dashboard/Cardview.vue';
import CommiunicationGridComponent from '@/components/App/Modules/GMS/Communication/Dashboard/CommiunicationGrid.vue';
import { AppConstants as _app } from "@/shared/app.constants";
import { http } from "@/shared/https";
import { Utilities as utils } from "@/shared/utilities";
import AuthService from "@/services/auth.service";
import { Locales } from "@/i18n/locales";

import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

const auth = new AuthService();

@Component({
  components: {
    CommunicationCardViewComponent,
    CommiunicationGridComponent,
  }
})
export default class CommiunicationDashboardListComponent extends Vue {
  isTabView: boolean = false;
  collapsed = false;
  items: Array<any> = [];
  filterKey: any;
  tabs = [
    { component: "CommunicationCardViewComponent", text: "Grid View", icon: "mdi-view-grid" },
    { component: "CommiunicationGridComponent", text: "Card View", icon: "mdi-format-list-bulleted-square" }
  ];
  currentTab = this.tabs[0];
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  mounted() {
    const self = this;
     this.$services.communication.getCommnicationList()
        .then((resp) => {
          self.items = resp.Items.map(x =>  {
          x.TotalProjectBudget = x.TotalProjectBudget ? utils.formatCurrency(x.TotalProjectBudget, x.BudgetCurrency, this.defaultLocale ) : ""; 
          x.RequestedAmount = x.RequestedAmount ? utils.formatCurrency(x.RequestedAmount, x.BudgetCurrency, this.defaultLocale ) : ""; 
          return x;
         });
        })
  }

  get currentTabComponent() {
    return this.currentTab.component;
  }

  switchLayout(isTabView) {
    this.isTabView = !isTabView;

    if (this.isTabView) {
      this.currentTab = this.tabs[1];
    } else {
      this.currentTab = this.tabs[0];
    }
  }


   /** edit the communication */
    editCommunication(card: any) {
        var commId = card.GrantCommunicationId.toString();
        this.$router.push({
            name: "communicationReports",
            params: { communicationId: commId }
        });
    }

        /** check button access rights */
    accessRights(card, btn) {
      //@ts-ignore
      return !card.IsInitialStep || this.$can(_app.actions.manage, _app.subjects.communication);
    }
}
